import * as config from "../config";
import "./localstorage-polyfill"

export default {
    get: function(key){
        var value = fnLocalStorage.getItem(config.STORAGE_PREFIX + key);
        if ((!value) || (value == "undefined")) {
          return ""
        }
        else {
          return value && JSON.parse(value);
        }
    },
    set: function(key,value){
        fnLocalStorage.setItem(config.STORAGE_PREFIX + key, JSON.stringify(value));
    },
    unset: function(key){
        fnLocalStorage.removeItem(config.STORAGE_PREFIX + key);
    }

};



// WEBPACK FOOTER //
// ./src/js/utilities/storage.jsx